import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';
import InputMask from 'react-input-mask';

const ForgotConfirmForm = forwardRef((props, ref) => {
  const { onSubmit } = props;
  const { register, handleSubmit, formState, control } = useForm({
    defaultValues: {
      code: '',
    },
  });

  useImperativeHandle(ref, () => ({
    handleSubmitForm: () => {
      handleSubmit((data) =>
        onSubmit({
          code: data.code,
        })
      )();
    },
  }));

  return (
    <form>
      <FormControl error={!!formState.errors.code} margin='normal' variant='outlined' fullWidth>
        <InputLabel>Код подтверждения</InputLabel>
        <Controller
          name='code'
          control={control}
          render={({ field }) => (
            <InputMask
              mask='999999'
              maskChar=''
              value={field.value}
              onChange={field.onChange}
              {...register(field.name, {
                pattern: /^[0-9]{6}$/iu,
                required: true,
              })}
              {...field}>
              {(inputProps) => (
                <OutlinedInput label='Код подтверждения' variant='outlined' fullWidth placeholder='489327' {...inputProps}></OutlinedInput>
              )}
            </InputMask>
          )}></Controller>
      </FormControl>
    </form>
  );
});

export default ForgotConfirmForm;
